import { useContext } from "react";
import { PropContext } from "../layout/PropContext";
import { Row } from "react-bootstrap";
import List from "../format/List";
import { checkURL } from "../util/api.mjs";

export default function Games() {
  const { assets } = useContext(PropContext);

  checkURL(assets.origin);
  if (assets.origin !== "games") return "...Loading";

  let items = {};
  for (const [key, value] of Object.entries(assets.images)) {
    items[key] = {
      image: value,
      description: assets.descriptions[key],
      link: assets.links[key],
    };
  }

  return (
    <>
      <Row>
        <p name="page description" id="page_description">
          A list of video games I enjoy. Clicking the game will open a new tab
          to its steam store page.
        </p>
      </Row>
      <Row>
        <List listName="games" itemType="card" items={items} />
      </Row>
    </>
  );
}
